<script>
import {FontSizeScale} from "@/common/directives/fontSizeScale";
export default {
  name: "hs-tag",
  directives: {
    FontSizeScale
  },
  props: {
    title: String,
    subTitle: String,
    active: Boolean,
  }
}
</script>

<template>
  <div class="hs-tag" :class="{actived: active}">
    <slot>
      <span>{{ title }}</span>
      <div class="sub-title" v-if="subTitle"><span v-font-size-scale="0.583">{{ subTitle }}</span></div>
    </slot>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-tag {
  @extend .flex-center;
  @extend .hs-font-body;
  flex-direction: column;
  width: calc(33.3% - 5.33px);
  background-color: $color_black_20;
  color: $color_black_600;
  padding: 2px 2px;
  height: 34px;
  margin-bottom: 12px;
  border-radius: 4px;
  text-align: center;
  border: 0.5px solid transparent;
  position: relative;
  &[type="white"]{
    border: 0.5px solid $color_black_40;
    background-color: $color_black_0;
    &.actived{
      border: 0.5px solid rgba(240, 24, 42, 0.2);
      &::after{
        display: none;
      }
    }
  }
  &[type="small"] {
    @extend .hs-font-caption-1;
    > .sub-title {
      font-size: 12px;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 4px 0 4px 0;
      background-color: $color_orange_300;
      height: 12px;
      color: $color_black_0;
      padding: 1px 2px;
      display: flex;
      align-items: center;

      > span {
        display: block;
      }
    }
  }

  &[type='gray40']{
    @extend .hs-font-caption-3;
    display: inline-flex;
    font-size: 12px;
    border: 0.5px solid $color_black_40;
    background-color: $color_black_0;
    color: $color_black_100;
    border-radius: 4px;
    height: 16px;
    >.title{
      padding: 0 4px;
    }
  }

  &[type="theme"] {
    &.actived{
      border: 0.5px solid transparent;
      &::after{
        display: none;
      }
    }
  }
  &[type="bgBlue"] {
    &.actived{
      border: 0.5px solid transparent;
      &::after{
        display: none;
      }
    }
  }
  &[type="yellow50"] {
    @extend .hs-font-overline-1;
    width: auto;
    height: 22px;
    padding: 2px 8px;
    background: $color_red_50;
    color: $color_red_300;
    &.actived{
      border: 0.5px solid transparent;
      &::after{
        display: none;
      }
    }
  }
  &[type="green50"] {
    @extend .hs-font-overline-1;
    width: auto;
    height: 22px;
    padding: 2px 8px;
    background: $color_green_50;
    color: $color_green_300;
    &.actived{
      border: 0.5px solid transparent;
      &::after{
        display: none;
      }
    }
  }
  &[type="theme"] {
    &.actived{
      border: 0.5px solid transparent;
      &::after{
        display: none;
      }
    }
  }
  &.actived {
    background: rgba(240, 24, 42, 0.04);
    border: 0.5px solid $color_theme_300;
    color: $color_theme_300;
    position: relative;

    &::after {
      position: absolute;
      bottom: 0;
      right: 0;
      content: ' ';
      width: 12px;
      height: 10px;
      border-radius: 4px 0 4px 0;
      background-color: $color_theme_300;
      background-image: url(@/assets/image/base/hs-tag/icons_12pt_right.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px 12px;
    }
  }
}
</style>
